{
  "01a8f136f22ef1a9": "Entering a device ID enables HostedTime punch sync for this workplace. Leave blank to keep the integration disabled.",
  "01ccbc19c3b372e3": "Long-lead threshold",
  "026b7a3a2f6d7697": "Request to Book settings updated successfully",
  "0293bf6baa4da730": "At least one professional type must be visible.",
  "029910631f5463b4": "Workers must request approval to book shifts that start within the number of hours you set.",
  "04ed8e5a76538624": "Allow Roster professionals to cancel shifts",
  "04f96eeb9c8090d1": "Job Management",
  "05d8e4ffb7e2376a": "When enabled, a professional's first shift at this workplace starts earlier to include time for orientation.",
  "067b254ae46f9580": "Shift cancellation setting updated.",
  "070a37fdf99a9b4b": "Error updating Maple integration. Please try again later.",
  "0b0ee7aea59f7a20": "Weekly hours limit must be no less than {{minimumHours}} hours",
  "0b7a1c4861e1a730": "Choose which credentials workers need to provide for timekeeping.",
  "0c0b0522c0dc7728": "Failed to save roster window settings. Please try again.",
  "0c5c6608de487c25": "Shift Starting Soon Threshold",
  "0cf365870c0ee8ec": "Pin only",
  "0e520b951ba12cc3": "Prevent professionals from booking double shifts",
  "0ece9ff6f24f85f5": "When enabled, workplace users will be able to share and manage charting credentials on behalf of workers.",
  "10028063dd2dfd0d": "Block professionals from booking excessive weekly hours",
  "11465f5fb599e324": "When enabled, booking a shift adds an unread message to your chat so your team is notified. When off, the chat updates silently without a notification.",
  "12c831575018380f": "Failed to request NFC tags.",
  "12f3883c328acb33": "Enter {{fieldName}}...",
  "1327eba28e201aa6": "Error updating badge requirement. Please try again later.",
  "141faceb777ac6c0": "Failed to update Start of Shift Orientation.",
  "1445799c033a2d17": "Learn more",
  "1509f561f2416598": "Save",
  "15b937dfd1192007": "Set badge requirements, sign-out methods, and charting compliance.",
  "160f3779e2189100": "No professional types configured for this workplace.",
  "16216d9aaa98d192": "Failed to update auto-decline setting.",
  "17ce210985676544": "Paid rest period policy",
  "18f41a84465f6462": "Edit policy",
  "19766ed6ccb2f4a3": "Cancel",
  "1dcfa9963127e7d0": "Manage jobs for my child facilities",
  "1f6fa6f69d185e60": "min",
  "20a3669ea603e118": "You have unsaved break policy changes. Are you sure you want to leave?",
  "21b66fba384beedc": "Rate & Billing",
  "225fa4e0fdaccf2d": "Roster window settings",
  "2272a1ceb0f4084b": "Failed to update setting",
  "245e2e6200d75f82": "Enabling the Maple integration will sync shifts with Maple for this workplace.",
  "257da42c62c99413": "Declination reason updated successfully.",
  "26cff35a43a92672": "Shifts posted within this many days of start are urgent and open to Clipboard immediately.",
  "2763e3a812c08d7a": "Manage booking modes and shift hour limits.",
  "2867be8d7523b61f": "Auto-approve settings updated successfully",
  "28cdd20eaf134a05": "minute",
  "29e2cad39d7468e7": "Control rate negotiation and billing integrations.",
  "2a3c8aeaa199cf52": "Failed to update NFC tag location.",
  "2a78025de6aae5e7": "Select",
  "2a9946d5fcbee4bc": "For shifts that exceed {{shiftHours}} hours, required break is {{breakMinutes}} minutes",
  "2b31bc9806c47521": "Restrict shift invites that would exceed 17 hours per day",
  "2b9d1e8092595413": "If this is turned on, professionals can propose a new pay rate, giving your workplace a fast way to fill more shifts.",
  "2be38aafe50a4f66": "Late-cancellation call notification",
  "2de9bd54d2237316": "Enable QR code sign out",
  "2f299751a552286f": "Orientation length must be a whole number between {{minimum}} and {{maximum}} minutes",
  "2f6ffdd61800cc85": "Enable Maple integration?",
  "30dd117c4f6b1bf9": "Maximum weekly hours",
  "31235ef8a9967bb8": "Roster settings saved.",
  "31ca56a9136579db": "Auto-verify shifts after clock-out (Grace Period)",
  "3251e2ac1ea2509c": "Disabling the Maple integration will stop all shift syncing with Maple for this workplace. This may cause the integration to become out of sync.",
  "32eb2aafbde6005b": "Setting updated successfully",
  "3411059cb8e0660e": "Spanish",
  "3418da3652d49b70": "Worker credential configuration updated successfully",
  "35322b5bb5a218a1": "Save Changes",
  "3598cecacb0c270f": "For medium-lead shifts, open to Clipboard this many days after posting.",
  "3618d4f084e7c98c": "Mandatory break rules updated successfully.",
  "362a5555c74569b3": "Configure clock-in restrictions, break policies, and attendance verification.",
  "3770d69cbbc0b4b1": "Enable auto-verify shifts after clock-out",
  "37c36d3083a02a9d": "Set the maximum number of consecutive work hours allowed within a 24-hour period.",
  "3cb794619991fb44": "Error updating grace period. Please try again later.",
  "3eabdb54abdd1e4d": "No rate and billing settings are available for this workplace.",
  "3f526863fa08c30d": "Shifts posted more than this many days before start use the long-lead rule.",
  "3ff700627da62ace": "Review and edit your facility's mandatory break policy",
  "404314b1f4bd8fa2": "hours",
  "417db1a458c4ea0d": "Medium-lead open after posting",
  "42dac2c38c3d6b20": "Update ID",
  "4496feb166897bf2": "Require a badge during shifts",
  "45c8b057b93a9fc8": "Late-cancellation call notification disabled successfully.",
  "464c4ffd019e1e96": "Edit",
  "467f1e45cb2e15d7": "HostedTime device ID updated successfully",
  "4782a946cda86e5b": "Error updating charting compliance. Please try again later.",
  "47c3da40b86b4093": "Start of Shift Orientation disabled successfully.",
  "4e11fb106fc1beaf": "Error updating facility profile",
  "4e39043d3b418b09": "Auto-approve past workers setting updated successfully",
  "4ea6b01896b99aaa": "Charting Compliance Grace Period",
  "4efca0d10c5feb8e": "About",
  "516815728ebada54": "Select facilities",
  "516a5e70deb6efdc": "Roster settings",
  "5306e22284383c9e": "Timekeeping",
  "5342e09f2729fbc6": "Enable",
  "55415f12f011587e": "Error updating HostedTime device ID. Please try again later.",
  "5a73db704d5aba8e": "Enter device ID",
  "5ad1562de87b82a2": "Has active shifts in the next 2 weeks",
  "5c6c5ecd903aa583": "Failed to load the roster window settings for this workplace.",
  "627ea0e020d09b9b": "Mandatory break disabled successfully.",
  "63019196ab3f47bc": "When enabled, professionals can be recalled to complete charting. Professionals with incomplete charting will also be blocked from booking at your workplace.",
  "63e5f13e75870180": "Shift starts within",
  "647335d7dbca9fe5": "Roster configuration for this workplace, including when each PRN shift opens to Clipboard professionals.",
  "648a4c19b1216439": "Controls when each PRN shift posted from this workplace opens to Clipboard professionals.",
  "65602a19e4ee5fd9": "Prevent professionals from booking excessive weekly hours",
  "66f76ecd947de45d": "Long-lead open before start",
  "67fe49da5dc9c9df": "Charting compliance updated successfully",
  "6c5b2cad2f85979d": "Charting Compliance",
  "6ce93b6727c1ec8a": "Provide optional paid rest periods",
  "6d8d199762d7dc91": "We couldn't load these settings.",
  "6ef0516afc1179be": "Number of hours before a shift starts to consider it 'starting soon' and highlight professionals who still need credentials.",
  "6f394b954182ea8e": "Error updating worker credential configuration. Please try again later.",
  "6f56d922c2975df3": "OTA Bundle ID",
  "6fb98324690491d0": "Enable Request to Book for last-minute shifts only",
  "709ce46141701cfb": "QR code sign out updated successfully",
  "712ee289a8a1a83a": "Require mandatory break",
  "74a883a037bc227f": "Settings",
  "759000dbc800b55f": "Failed to update declination reason.",
  "766e59dd3e549867": "Failed to update mandatory break rules.",
  "7688d2f7598780ca": "Mandatory break policy updated successfully.",
  "76eef37fa34912c2": "HostedTime integration device ID",
  "774e9813ce70b676": "Disable Maple integration?",
  "793547cb531c7a70": "For long-lead shifts, open to Clipboard this many days before shift start.",
  "7b1adb15b1899b5e": "Choose your preferred language for the redesigned pages.",
  "7c95a22d84b8d584": "Failed to delete NFC tag.",
  "7e6fefff0f0aeb6c": "Hidden",
  "7e8e9084e6c5087a": "Edit Start of Shift Orientation",
  "81b7aedb5393dc88": "Start of Shift Orientation updated successfully.",
  "84cbe21ac1b40897": "Error updating workplace's profile. Please try again later.",
  "851c9851d07cd16f": "Enable Request to Book",
  "87f82bcdf0731618": "Auto-decline break requests disabled successfully.",
  "8a029165f3237a43": "Threshold must be no less than {{minimumHours}} hours",
  "8cd5c736de3b93e6": "Failed to update shift-booked notifications.",
  "8df23bc99cbf8662": "Failed to update mandatory break setting.",
  "8e3323ee7d5c7ed9": "Rest breaks disabled successfully.",
  "8ed3f28051797677": "When enabled, Clipboard will call the specified number per the instructions below if a professional cancels within 8 hours of the shift start time or no-shows.",
  "900b85f3c4e41b75": "Maximum consecutive hours",
  "90e63d85fa1ab2c8": "minutes",
  "936e661e1282b74a": "This workplace requires that all Independent Contractors using Clipboard wear a badge at all times during a shift.",
  "942087cc2d41e013": "Retry",
  "94f86357ea8d33f9": "Urgent threshold cannot be greater than the long-lead threshold.",
  "9578186350a9aa2d": "Edit declination reason",
  "962906f4f658a9a2": "Location updated successfully",
  "9731e4f3a4426da4": "Request to Book threshold hours updated successfully",
  "990e61f759a1f123": "Is this workplace integrated with Maple?",
  "9a1ac0f4474c012b": "Rest break policy updated successfully.",
  "9bf39a1c52cfe90e": "Edit call instructions",
  "9c44b4cfe4f02691": "Enable Instant Book for previously approved professionals",
  "9d481643628c5d4e": "Break length in minutes",
  "9fb7286cb8e833d0": "Failed to update rest break setting.",
  "a06e6300e86256b9": "Edit paid rest period policy",
  "a0be4aaec8295265": "Allow professionals to propose rates on shifts",
  "a128ad6c18e63fc5": "Late-cancellation call notification updated successfully.",
  "a29b245ffea6c861": "Tags requested successfully",
  "a2f2d551f1bf2d43": "Roster window settings saved.",
  "a307781c6d410504": "Call instructions",
  "a3b28bc1ac2c4a56": "Grace period updated successfully",
  "a4382a439a776868": "Worker Credentials",
  "a4db3f810f1f66c9": "Get notified when a shift is booked",
  "a4fe65264ef7dbb3": "Language",
  "a6677f62a5e6437c": "Time & Attendance",
  "a6a219dce5737ccf": "Review and edit late-cancellation call instructions",
  "a6f7b34c25b558f1": "Error saving calendar settings. Please try again later.",
  "a752a5ec88bbf67d": "Enable Instant Book for past workers",
  "a912692269072e1d": "The duration in hours a professional has to return and complete charting.",
  "a9b847b2689edc15": "Calendar Display",
  "a9c5f50f24ffd660": "Toggle on to automatically verify shifts that clock out shortly after their scheduled end time. Only applied when shift extension is enabled for this workplace.",
  "aaefaa4c202b693c": "Automatically decline expiring break payment requests",
  "ab51004e9d71a485": "days",
  "aba5efd1a814f972": "Block professionals from booking excessive consecutive hours",
  "adbcd39b8810299a": "Failed to update rest break policy.",
  "ae09c55e1b7e4d04": "Urgent threshold",
  "aed4b0940be3c757": "Weekly hours limit must be no more than {{maximumHours}} hours",
  "aee6b41152429015": "Mandatory break policy",
  "aef7de28d52977f1": "Server",
  "af40ec4cf6746601": "Late-cancellation call instructions",
  "b1c733b78cb882ff": "Move {{label}} down",
  "b1cfc10aede4c39f": "Declination reason",
  "b2b3611957143755": "Credential Variant",
  "b3aab3f479896b30": "When enabled, workplace users cannot send invites that would cause a professional to work more than 17 hours within a 24-hour period.",
  "b608751ba11761e1": "Failed to update shift cancellation setting. Please try again.",
  "b6c6b18b606c202c": "When enabled, workers can submit their timesheet without a workplace signature.",
  "b7e3e4aa4257b9a1": "Disable",
  "b9d5e7d60c6b2145": "Error updating rate negotiation setting. Please try again later.",
  "ba118bf7fc9c1aed": "English",
  "bafba7a74c5477f4": "Select the facilities that you want to manage jobs for.",
  "bdd254b65baac169": "Build",
  "bf8d19636791d7d7": "Add Extended Break Rule",
  "c02747ac5f5c7273": "Auto-verify threshold in minutes",
  "c0a5092344cc22aa": "Failed to save roster settings. Please try again.",
  "c0aa98240e66b4c9": "Configure worker type visibility and ordering on the calendar.",
  "c587ea41a339ba29": "Set the maximum number of work hours allowed per week (Sunday to Saturday).",
  "c5b6f7fc03f24904": "Failed to update mandatory break policy.",
  "c5fd090e8930f78e": "Review and edit the paid rest period policy",
  "c611981fab983bc6": "Policy",
  "c6a43821f5032216": "Native Build",
  "c78ffe19571018fb": "Platform",
  "c88a1f4319eaaf8d": "Add any additional breaks for longer shift lengths here. When selected, workers will be required to take the set break length for the shift length defined below.",
  "c8cfe723d85dcdd3": "We will not charge you for clocked time before a shift's posted start time. Only applies to shifts worked after making this change. Please note that this may affect punctuality.",
  "cabfc417fcda90b4": "When enabled, workplace users will be able to share and manage timekeeping credentials on behalf of workers.",
  "cb02f5f5f85042d2": "Restrictions must be no less than {{minimumHours}} hours",
  "cb0e058f95cae151": "Tag deleted successfully",
  "cc3412a260c1fee8": "When enabled, the rest period policy will be visible to professionals in the app.",
  "cd4b05265dcdad59": "Skip workplace signature on timesheet submission",
  "cddc9d387f818111": "Start of Shift Orientation",
  "cf3b00d3f19d1a1f": "To modify the workplace's Request to Book setting, submit a request in #proj-request-to-book",
  "cf7da5d7167f32c7": "Rate negotiation setting updated successfully",
  "cfa3e1caf0b1b2d8": "Prevent professionals from clocking in early",
  "d020f667999d89b9": "Shift length in hours",
  "d1f552dbcd765ea2": "Failed to load the roster settings for this workplace.",
  "d2752a3342c348f8": "No job management settings are available for this workplace.",
  "d745023be91784c2": "Schedule preferences updated successfully",
  "d8b8392e2c542950": "Try again",
  "d92c232bd70bea33": "Orientation length",
  "da50017b4af59e26": "Any qualification",
  "da53b30af3fef836": "Failed to update late-cancellation call notification.",
  "da9d85b8c6acc03a": "update settings",
  "db7ee8ce4a71ce8b": "Start of Shift Orientation configuration",
  "dbc054563c1abbc4": "Set how many hours before a shift starts that Request to Book is required.",
  "dc937b59892604f5": "None",
  "dce23e196411bb19": "Badge requirement updated successfully",
  "dd167905de0defca": "Version",
  "de6f98ae0bbb9c6e": "Configure worker credentials for charting and timekeeping, and configure the onboarding view.",
  "dfb40b548c292714": "Remove break rule",
  "e0350a790c9138d1": "Onboarding View",
  "e1fc7d1f6da04cae": "If this is turned on, professionals can propose a new pay rate, giving your workplace a fast way to fill more shifts. Learn more at the support center.",
  "e377b97aea9f238e": "When off, PRN professionals can't cancel a shift they've claimed, and the cancel button is hidden in their app.",
  "e5c1a2c44b487954": "Error updating QR code sign out. Please try again later.",
  "e5c54aa7e72bb752": "Maple integration updated successfully",
  "e7f458685df1a5c3": "Visible on calendar",
  "e891d5cd0ea25608": "HostedTime device ID",
  "e9d01a96cb9107e8": "Qualification-specific orientation",
  "ec37e0df8aea84f1": "Only administrators can change these settings. Contact Clipboard support to request changes.",
  "ec6dd417ce5e7977": "App version and update information.",
  "ed5c58303a981baa": "Scheduling",
  "ed7d194dfdf2d7d2": "Enter a default declination reason to use at the end of the review window",
  "ef593bf59fb4f1a1": "Updated settings",
  "f01334330fe346ac": "Leave empty to apply orientation at the workplace level: only a single orientation is required for a professional for any qualification. Select qualifications to require orientation only for those, with each completed orientation counting toward the qualification it covered.",
  "f0dfe26e63bc8617": "Manage job settings for child facilities.",
  "f33866ec4557e416": "Pin + Password",
  "f4022f08f2be1d48": "When enabled, expiring break payment requests will be declined. When disabled, they will be approved.",
  "f46c7130506f2478": "Compliance & Documentation",
  "f4d573798f5b25fe": "Charting",
  "f714dda64c6790b5": "Shifts will be automatically verified for clocking out up to {{minutes}} {{unit}} over their scheduled shift end time. Only applied when shift extension is enabled for this workplace.",
  "f81ab834de5f8491": "Reason",
  "f91bbb0188572f4b": "Show or hide professional types on the calendar. Use arrows to reorder.",
  "fa432f02d32b7530": "When enabled, shows professionals who are missing credentials and have upcoming shifts, so credentials can be shared before their shift starts.",
  "fa9f08cef921d924": "Calendar settings saved successfully",
  "faf0d21f68cb1219": "Shift-booked notifications updated successfully.",
  "fbb406ff9171f080": "When enabled, staff at your workplace can scan a QR code to provide signatures and anonymous feedback at the end of shifts.",
  "fcbd1eaf717dc48b": "Auto-decline break requests enabled successfully.",
  "fe5d18d769b290af": "Move {{label}} up"
}
